<template>
  <div class="supplierManagement">
     <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>

    <div class="setNavBg">
       <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-recruitmentBanner :bannerInfo="bannerInfo"></v-recruitmentBanner>
    <div class="supplierManageCon">
      <p>
        <span>一链供应商管理平台定位于各个行业，为入驻采购企业提供丰富的平台供应商资源，支持自定义企业供应商库。</span>
        <span>提供供应商全生命周期管理工具，同时对接第三方征信接口，让企业全方位了解供应商的征信级别，舆情动态。同时可与一链网其他产品无缝组合，支撑业务过程管控，渗透供方管理各场景应用。</span>
      </p>
      <button type="button" class="btn btn-default btn-lg" @click="centerDialogVisible = true">立即体验</button>
    </div>
    <div class="supplierManageList">
      <ul class="row clearfix">
        <li class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div class="clearfix">
            <span class="col-xs-1 col-sm-1 col-md-1 col-lg-2">
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplierManageList_icon01.png" alt="">
            </span>
            <div class="supplierManageLiCon col-xs-11 col-sm-11 col-md-11 col-lg-10 pull-right">
              <h4>寻源与招募</h4>
              <p>网罗丰富供应商资源</p>
              <p>按需筛选、高效检索</p>
            </div>
          </div>
        </li>
        <li class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div class="clearfix">
            <span class="col-xs-1 col-sm-1 col-md-1 col-lg-2">
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplierManageList_icon02.png" alt="">
            </span>
            <div class="supplierManageLiCon col-xs-11 col-sm-11 col-md-11 col-lg-10 pull-right">
              <h4>供应商准入</h4>
              <p>建立健全供应商准入机制</p>
              <p>规则明确、阳光透明</p>
            </div>
          </div>
        </li>
        <li class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div class="clearfix">
            <span class="col-xs-1 col-sm-1 col-md-1 col-lg-2">
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplierManageList_icon03.png" alt="">
            </span>
            <div class="supplierManageLiCon col-xs-11 col-sm-11 col-md-11 col-lg-10 pull-right">
              <h4>供应商评估</h4>
              <p>流程简单，评估更高效</p>
              <p>模板灵活，评估更量化</p>
            </div>
          </div>
        </li>
        <li class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div class="clearfix">
            <span class="col-xs-1 col-sm-1 col-md-1 col-lg-2">
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplierManageList_icon04.png" alt="">
            </span>
            <div class="supplierManageLiCon col-xs-11 col-sm-11 col-md-11 col-lg-10 pull-right">
              <h4>供应商评级</h4>
              <p>根据评估结果对供应商分级，实现供应</p>
              <p>商梯队建设，良性循环</p>
            </div>
          </div>
        </li>
        <li class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div class="clearfix">
            <span class="col-xs-1 col-sm-1 col-md-1 col-lg-2">
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplierManageList_icon05.png" alt="">
            </span>
            <div class="supplierManageLiCon col-xs-11 col-sm-11 col-md-11 col-lg-10 pull-right">
              <h4>供应商黑名单</h4>
              <p>有效规范供应商业务行为</p>
              <p>底线原则，提高风险意识</p>
            </div>
          </div>
        </li>
        <li class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div class="clearfix">
            <span class="col-xs-1 col-sm-1 col-md-1 col-lg-2">
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/supplierManageList_icon06.png" alt="">
            </span>
            <div class="supplierManageLiCon col-xs-11 col-sm-11 col-md-11 col-lg-10 pull-right">
              <h4>绩效改进</h4>
              <p>供应商整改更有目标</p>
              <p>供应商培训更有方向</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
      title=""
      custom-class="experienceDialog"
      :visible.sync="centerDialogVisible"
      :lock-scroll="false"
      width="30%"
      center>
      <p class="hotline">如需更好的了解一链采购供应链数智化系统，寻求更多采购供应链解决方案，入驻成为平台采购商，请您填写以下信息，或拨打免费服务热线：<span>400-108-6116</span></p>
      <el-form :model="ruleForm" :rules="rules" ref="recruitForm" label-width="92px" class="demo-ruleForm">
        <!--<el-form-item label="角色" prop="roleName">-->
          <!--<el-select v-model="ruleForm.roleName" placeholder="请输入角色">-->
            <!--<el-option-->
              <!--v-for="item in options"-->
              <!--:key="item.value"-->
              <!--:label="item.label"-->
              <!--:value="item.value">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->
<!--        <el-form-item label="角色" prop="roleName">-->
<!--          <el-radio-group v-model="ruleForm.roleName">-->
<!--            <el-radio v-for="item in options" :label="item.value" :key="item.value">{{item.label}}</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
        <el-form-item label="姓名" prop="userName">
          <el-input v-model="ruleForm.userName" placeholder="请输入姓名" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="positionName">
          <el-input v-model="ruleForm.positionName" placeholder="请输入职位" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contractPhone">
          <el-input v-model="ruleForm.contractPhone" placeholder="请输入联系电话" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="ruleForm.companyName" placeholder="请输入公司名称" :maxlength="50"></el-input>
        </el-form-item>
<!--        <el-form-item label="试用平台" prop="trialPlatform">-->
<!--          <el-checkbox-group v-model="ruleForm.trialPlatform" @change="handleChange">-->
<!--            <el-checkbox label="采招平台" ></el-checkbox>-->
<!--            <el-checkbox label="协同平台" ></el-checkbox>-->
<!--            <el-checkbox label="供应商管理" ></el-checkbox>-->
<!--            <el-checkbox label="征信产品" ></el-checkbox>-->
<!--          </el-checkbox-group>-->
<!--        </el-form-item>-->
        <div class="clearfix">
          <div class="trialPlatform-label pull-left">
            <i style="color: #f56c6c;">*</i>
            我的需求
            <el-tooltip class="item" effect="dark" content="贵公司希望通过一链网，解决当前采购遇到的哪些问题？" placement="top">
              <el-button type="text" style="vertical-align: middle;">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </div>
          <div class="pull-left trialPlatform-item" style="width: 300px;font-size: 12px">
            <el-form-item label-width="0" prop="trialPlatform">
              <el-input v-model="ruleForm.trialPlatform"
                        style="font-size: 12px;"
                        type="textarea"
                        :maxlength="100"
                        :show-word-limit="true"
                        placeholder="如 电子招标、供应商管理、合同管理"
                        :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()">提交</el-button>
      </div>
    </el-dialog>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import recruitmentBanner from '@/components/recruitmentBanner'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  export default {
    props: [],
    data () {
       var checkMobile = (rule, value, callback) => {
        var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        var isMob=  /^0\d{2,3}-?\d{7,8}$/;// 座机格式
        if (!reg.test(value)&&!isMob.test(value)) {
          return callback(new Error('请输入有效的联系电话'));
        }else{
          return callback();
        }
      };
      return {
        options: [{
          value: '0',
          label: '采购商'
        }, {
          value: '1',
          label: '供应商'
        }],
        footerColumnInfos: [],
        navigationColumnInfos:[],
        bannerInfo: {name: '供应商管理', eng: 'Supplier Management'},
        webConfigInfo: {},
        messageData: [],
        messageTotal:0,
        currentPage:1,
        centerDialogVisible:false,
        ruleForm: {
          // roleName: '',
          userName: '',
          positionName: '',
          contractPhone: '',
          companyName: '',
          trialPlatform: ''
        },
        checkList:[],
        rules: {
          // roleName: [
          //   { required: true, message: '请选择角色', trigger: 'change' }
          // ],
          userName: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          companyName: [
            { required: true, message: '请输入公司名称', trigger: 'blur' }
          ],
          positionName: [
            { required: true, message: '请输入职位', trigger: 'blur' }
          ],
          contractPhone: [
            { required: true, message: '电话不能为空', trigger: 'blur' },
            { validator: checkMobile, trigger: 'blur' }
          ],
          trialPlatform: [
            { required: true, message: '请输入您的需求', trigger: 'blur' }
          ]
        },
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{}
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-recruitmentBanner': recruitmentBanner,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    created () {
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
    },
    methods: {
      submitForm() {
        this.$refs['recruitForm'].validate((valid) => {
          if (valid) {
            this.$axios.post('/onelink.mdata.main.api/task/addTaskInfo', {
              taskSource: 0,
              // roleName: this.ruleForm.roleName,
              userName: this.ruleForm.userName,
              positionName:this.ruleForm.positionName,
              contractPhone: this.ruleForm.contractPhone,
              companyName: this.ruleForm.companyName,
              trialPlatform: this.ruleForm.trialPlatform,
              operateStaus: 0
            }).then((res) => {
              this.data = res.data;
              let operateNumber = this.data.data;
              if(res.data.code == '0'){
                if(this.getToken('isLogin') == ''){

                  if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: '<strong>试用申请已提交,请到PC端, <span style="color:red">三分钟快速注册</span></strong>'
                    });
                    return;
                  } else {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: '<strong>试用申请已提交, <a href="/register" style="color:red">三分钟快速注册</a></strong>'
                    });
                    return;
                  }



                }else{
                  this.$message({
                     message: "试用申请已提交",
                     type: 'success'
                 });
                }
                 this.centerDialogVisible = false;
              }else{
                this.$message({
                     message: "试用提交失败!",
                     type: 'error'
                 });
              }
            }).catch((err) => {
              console.log(err)
            })
          } else {
            return false;
          }
        });
      },
      // handleChange(value){
      //   this.ruleForm.trialPlatform = value;
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/supplierManagement/index.vue